import { IPolicyDescriptor } from "../model";
import { DatePolicy } from "./datepolicy/datePolicy";

const PolicyContainer: Array<IPolicyDescriptor> = [
  {
    name: "DatePolicy",
    function: DatePolicy,
    params: {
      expirationDate: {
        description: "라이선스 만기일",
      },
    },
  },
];

export { PolicyContainer };
